// extracted by mini-css-extract-plugin
export default {"mainContainer":"Review_mainContainer__kOyFj","userListBox":"Review_userListBox__8r+IW","actionBox":"Review_actionBox__MErtz","actionButtonsBox":"Review_actionButtonsBox__sscz6"};